import { ApolloCache, gql } from '@apollo/client';

export const GetMyFindTagAssignmentsQueryName =
  'GetMyFindTagAssignments';

export const GET_MY_FIND_TAG_ASSIGNMENTS_QUERY = gql`
  query ${GetMyFindTagAssignmentsQueryName} {
    getMyFindTagAssignments {
      findId
      tags
    }
  }
`;

export interface FindTagAssignment {
  __typename?: 'FindTagAssignment';
  findId: string;
  tags: string[];
}

export interface MyFindTagAssignmentsData {
  getMyFindTagAssignments: FindTagAssignment[];
}

export const updateFindTagAssignmentInCache = (
  cache: ApolloCache<unknown>,
  find: { id: string; tags?: string[] | null }
) => {
  const data = cache.readQuery<MyFindTagAssignmentsData>({
    query: GET_MY_FIND_TAG_ASSIGNMENTS_QUERY,
  });

  if (!data) {
    return;
  }

  const assignments = data.getMyFindTagAssignments.filter(
    (assignment) => assignment.findId !== find.id
  );

  if (find.tags?.length) {
    assignments.push({
      __typename: 'FindTagAssignment',
      findId: find.id,
      tags: find.tags,
    });
  }

  cache.writeQuery<MyFindTagAssignmentsData>({
    query: GET_MY_FIND_TAG_ASSIGNMENTS_QUERY,
    data: { getMyFindTagAssignments: assignments },
  });
};

export const removeFindTagAssignmentsFromCache = (
  cache: ApolloCache<unknown>,
  findIds: readonly string[]
) => {
  const data = cache.readQuery<MyFindTagAssignmentsData>({
    query: GET_MY_FIND_TAG_ASSIGNMENTS_QUERY,
  });

  if (!data) {
    return;
  }

  const removedIds = new Set(findIds);

  cache.writeQuery<MyFindTagAssignmentsData>({
    query: GET_MY_FIND_TAG_ASSIGNMENTS_QUERY,
    data: {
      getMyFindTagAssignments: data.getMyFindTagAssignments.filter(
        (assignment) => !removedIds.has(assignment.findId)
      ),
    },
  });
};
